<div class="wlp-layout">

    <div class="wlp-scroll">
        <p class="wlp-intro">
            Please provide your work location details. City and State are required.
        </p>

        <form [formGroup]="form">
            <div class="skid-section">
                <h4 class="skid-section-title">Work Address</h4>
                <div class="grid">
                    <div class="col-12 md:col-6">
                        <label class="modal-label">Address 1</label>
                        <input pInputText formControlName="address1" placeholder="Enter address line 1" class="w-full" />
                    </div>
                    <div class="col-12 md:col-6">
                        <label class="modal-label">Address 2</label>
                        <input pInputText formControlName="address2" placeholder="Enter address line 2" class="w-full" />
                    </div>
                    <div class="col-12 md:col-6">
                        <label class="modal-label">City <span class="req">*</span></label>
                        <input pInputText formControlName="city" placeholder="Enter city" class="w-full"
                            [class.p-invalid]="f['city'].invalid && f['city'].touched" />
                        @if (f['city'].invalid && f['city'].touched) {
                        <small class="modal-error">City is required.</small>
                        }
                    </div>
                    <div class="col-12 md:col-6">
                        <label class="modal-label">State <span class="req">*</span></label>
                        <input pInputText formControlName="state" placeholder="Enter state" class="w-full"
                            [class.p-invalid]="f['state'].invalid && f['state'].touched" />
                        @if (f['state'].invalid && f['state'].touched) {
                        <small class="modal-error">State is required.</small>
                        }
                    </div>
                    <div class="col-12 md:col-6">
                        <label class="modal-label">Zip Code</label>
                        <input pInputText formControlName="zip" placeholder="Enter zip code" class="w-full" />
                    </div>
                    <div class="col-12 md:col-6">
                        <label class="modal-label">Country</label>
                        <input pInputText formControlName="country" placeholder="Enter country" class="w-full" />
                    </div>
                </div>
            </div>
        </form>
    </div>

    <div class="wlp-footer">
        <button type="button" class="modal-btn-cancel" (click)="cancel()">Cancel</button>
        <button type="button" class="modal-btn-primary" (click)="save()" [disabled]="isSaving">
            {{ isSaving ? 'Saving...' : 'Save Work Location' }}
        </button>
    </div>

</div>
